import React from "react";
import alert from "../../assets/alert.png";
import { TCText } from "../TCText/TCText";
import { Colors } from "../../utils/colors";
import { observer } from "mobx-react-lite";
import { useCourtBookingStore } from "../../stores/StoreContext";
import { convertToHours } from "../../utils/utils";

type props = {};

export const MinimumPlayingTime: React.FC<props> = observer(() => {
  const courtBookingStore = useCourtBookingStore();
  return !courtBookingStore.isMinimumPlayingTimeCovered ? (
    <div
      style={{
        backgroundColor: "rgba(212, 175, 96, 0.2)",
        height: 36,
        width: "100%",
        maxWidth: "800px",
        margin: "10px auto 20px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: 12,
        gap: 10,
      }}>
      <img src={alert} alt="" style={{ height: 16, width: 16 }} />
      <TCText
        style={{ fontWeight: 500, fontSize: 10, color: Colors.yellow }}
        value={`Minimum playing time is ${convertToHours(
          courtBookingStore.minimumPlayingTime
        )}`}
      />
    </div>
  ) : null;
});
